import { FC } from 'react';

const Span: FC<{ html: string }> = ({ html }) => {
  return <span dangerouslySetInnerHTML={{ __html: html }} />;
};

export default Span;
